import { createContext, Dispatch, PropsWithChildren, SetStateAction, useState } from 'react';

interface SidebarVisibility {
  isSidebarVisible: boolean;
  setSidebarVisibility: Dispatch<SetStateAction<boolean>>;
}

const SidebarVisibilityContext = createContext<SidebarVisibility>({
  isSidebarVisible: false,
  setSidebarVisibility: () => {},
});
export default SidebarVisibilityContext;

export function SidebarVisibilityContextProvider({ children }: PropsWithChildren) {
  const [isSidebarVisible, setSidebarVisibility] = useState(false);

  return (
    <SidebarVisibilityContext.Provider value={{ isSidebarVisible, setSidebarVisibility }}>
      {children}
    </SidebarVisibilityContext.Provider>
  );
}
